// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__pmue9","inner":"Footer_inner__SikFw","right":"Footer_right__1W37T","copy":"Footer_copy__eLgKf"};